import {Moment} from 'moment-timezone';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {ValueAndLabelModel} from '../../../../../common/model/valueAndLabel.model';
import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';
import {WorkflowTaskSummaryModel} from '../../../../../workflow/task/api/model/common/workflowTaskSummary.model';
import {PartnerSummaryModel} from '../../../../common/api/model/partnerSummary.model';

export class PartnerContactModel extends WithPermissionModel {
    id: number;
    partner: PartnerSummaryModel;
    mode: ValueAndLabelModel;
    direction: ValueAndLabelModel;
    date: Moment;
    type: LovValueSummary;
    rating: number;
    comment: string;
    otherInvolvedPartner: PartnerSummaryModel;
    email: WorkflowTaskSummaryModel;
}
